module.exports = __webpack_public_path__ + "img/horizontal_4_7_r_pp1_3016.eeb37550.png";